// The additional organization is enabled only in explicitly selected dev builds.
export const ICH_ORG_ID = "a25f9e42-23cd-11ec-9068-066917b38554";
export const DEV_ICH_ORG_ID = "fe925274-c053-11f1-8d22-16fff51c46bb";
export const IS_DEVELOPMENT_DEPLOYMENT = process.env.REACT_APP_DEPLOYMENT_STAGE === "dev";
export const ICH_ORG_IDS = Object.freeze([
	ICH_ORG_ID,
	...(IS_DEVELOPMENT_DEPLOYMENT ? [DEV_ICH_ORG_ID] : [])
]);
export const isIchOrganization = (orgId = "") => ICH_ORG_IDS.includes(String(orgId || "").trim().toLowerCase());
